<div class="banner">
  <img src="../../../../assets/images/gurantee.png" width="25px" />
  <span>平台安全有保障，工单客服在线时间8:00-24:00</span>
</div>

<mat-icon class="close" mat-dialog-close>close</mat-icon>

<div class="platform-info">
  <app-image [fileid]="data?.icon" [radius]="8"></app-image>

  <div class="name">
    <h1>{{ data.name }}</h1>
    <div
      class="old"
      *ngIf="
        (data.popcornStatus || !self) &&
        (data.name === '爆米花' || selected?.group === '爆米花电脑客户端')
      "
    >
      ￥
      {{
        (exclusive ? selected?.exclusive_price : selected?.price) || 0 | number
      }}
    </div>
    <div class="price">
      <span class="rmb">￥</span>
      <ng-container
        *ngIf="
          (data.popcornStatus || !self) &&
            (data.name === '爆米花' || selected?.group === '爆米花电脑客户端');
          else Else
        "
      >
        <span class="price">
          {{
            (exclusive
              ? selected?.exclusive_price * 0.5
              : selected?.price * 0.5) || 0 | number
          }}
          <span style="font-size: 14px">首单五折</span>
        </span>
      </ng-container>
      <ng-template #Else>
        <span class="price">{{
          (exclusive ? selected?.exclusive_price : selected?.price) || 0
            | number
        }}</span>
      </ng-template>
    </div>
  </div>
</div>

<div class="divider"></div>

<ng-container *ngIf="!loading; else loadingTemplate">
  <div class="content">
    <div class="selection duration" *ngIf="busTypeList.length > 0">
      <h1>{{ data.duration_display || "时长" }}</h1>
      <div class="items">
        <ng-container *ngFor="let n of busTypeList">
          <ng-container *ngIf="n.length > 0">
            <div>
              <button
                mat-raised-button
                [color]="selected?.name === n[0].name ? 'primary' : 'default'"
                (click)="selectName(n)"
              >
                {{ n[0].name }}
              </button>
            </div>
          </ng-container>
          <ng-container *ngIf="!n.length">
            <div>
              <button
                mat-raised-button
                [color]="selected?.name === n.name ? 'primary' : 'default'"
                (click)="selectName(n)"
              >
                {{ n.name }}
              </button>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <div class="selection group" *ngIf="grouped">
      <h1>{{ data.group_display || "分类" }}</h1>
      <div class="items">
        <div *ngFor="let g of busTypeGroups">
          <button
            mat-raised-button
            [color]="selected?.id === g.id ? 'primary' : 'default'"
            (click)="selectGroup(g)"
          >
            {{ g.group || "默认" }}
          </button>
        </div>
      </div>
    </div>

    <div
      class="selection seat"
      *ngIf="data.seat_display !== '--' && busTypeList.length > 0"
    >
      <h1>{{ data.seat_display || "车位" }}</h1>
      <div class="items">
        <div>
          <button
            mat-raised-button
            [color]="!exclusive ? 'primary' : 'default'"
            (click)="exclusive = false"
            [disabled]="
              selected?.delivery_method === 'User' ||
              selected?.delivery_method === 'None'
            "
          >
            拼车
          </button>
        </div>
        <div>
          <button
            mat-raised-button
            *ngIf="selected?.allow_exclusive"
            [color]="exclusive ? 'primary' : 'default'"
            (click)="exclusive = true"
            [disabled]="
              selected?.delivery_method === 'User' ||
              selected?.delivery_method === 'None'
            "
          >
            包车
          </button>
        </div>
      </div>
    </div>

    <div class="tips">
      <span>
        {{ (exclusive ? selected?.exclusive_tips : selected?.tips) || "" }}
      </span>
    </div>

    <!-- <div
      class="divider introduce-divider"
      *ngIf="data.product_detail || data.product_image"
    ></div> -->
    <!--<div class="introduce" *ngIf="data.product_detail">
      <div class="introduce-title">商品介绍</div>
      <div class="introduce-detail">
        {{ data.product_detail }}
      </div>
    </div>
    <div class="introduce" *ngIf="data.product_image">
      <div class="introduce-title">商品详情</div>
      <img
        class="introduce-pic"
        src="/api/files/{{ data.product_image }}"
        alt=""
      />
    </div> -->

    <!-- <div class="introduce" [innerHTML]="data.product_detail"></div> -->
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <mat-spinner [diameter]="64"></mat-spinner>
</ng-template>

<!-- <div class="coupon">
  <span>优惠码</span>
  <div class="spacer"></div>
  <input
    [(ngModel)]="couponCode"
    placeholder="点击此处输入优惠码"
    spellcheck="false"
  />
  <button mat-flat-button (click)="checkCouponCode()">检查</button>
</div> -->

<div class="button">
  <button
    mat-raised-button
    color="primary"
    class="purchase"
    [disabled]="!selected"
    (click)="purchase()"
  >
    立即购买
  </button>
</div>
